{
  "#KUNDENINFO_LEISTE": {
    "TITLE": "Kundeninfo",
    "LABEL_KUNDE": "Kunde ",
    "LABEL_SALDO_FAELLIG": "Saldo Fällig:",
    "LABEL_ZAHLART": "Zahlart:",
    "LABEL_ZAHLKOND": "Zahlkond:",
    "LABEL_KREDITLIMIT": "Kreditlimit:",
    "LABEL_KREDITLIMIT2": "Kreditlimit2:",
    "LABEL_VERSICHERUNGSLIMIT": "Versicherungslimit:",
    "LABEL_VERTRETER": "Vertreter:",
    "LABEL_IBAN": "IBAN:",
    "LABEL_BIC": "BIC:",
    "LABEL_KONTONUMMER": "Kontonummer:",
    "LABEL_BLZ": "BLZ:",
    "LABEL_KEINE_DATEN": "Keine Daten zum Anzeigen vorhanden"
  }
}
